<template>
  <div
    v-loading="isLoading"
    element-loading-text="Verifying..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="w-full h-screen"
  >
    <div class="flex justify-start w-full m-16">
      <logo-icon />
    </div>
    <!-- <div class="flex h-4/5 justify-center items-center">
      <div
        class="border-2 w-full border-gray-2 rounded-2xl sm:w-4/5 md:w-96 pt-12 md:px-12 px-6 p-1"
      >
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  data () {
    return {
      verifyDetails: {
        code: '',
        userID: ''
      },
      isLoading: false
    }
  },
  mounted () {
    this.verifyDetails.code = this.$route.query.code
    this.verifyDetails.userID = this.$route.query.userID
    this.verifyEmail()
  },
  methods: {
    verifyEmail () {
      if (!this.verifyDetails.code || !this.verifyDetails.userID) {
        this.$router.push('login')
        return
      }
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('auth/verifyEmail', { ...this.verifyDetails })
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Your Email has been verified!',
            confirmButtonText: 'Go to homepage',
            iconColor: 'var(--color-primary)',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'dashboard' })
            }
          })
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
          this.$swal({
            icon: 'error',
            title: 'Something went wrong',
            html: err,
            confirmButtonText: 'Go to homepage',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'dashboard' })
            }
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style>
.el-loading-spinner .el-loading-text {
  color: var(--color-primary) !important;
}
.el-loading-spinner i {
  color: var(--color-primary) !important;
}
</style>
